import { Box } from "@mui/material";
import { isDesktop } from "react-device-detect";

import { ColorScheme } from "../../Themes/ColorScheme";
import { MainpageContainer } from "./MainpageContainer";

export const Mainpage = () => (
	<Box
		sx={{
			backgroundColor: ColorScheme.background,
			minHeight: isDesktop ? "100vh" : "100dvh",
			overflow: "hidden"
		}}
	>
		<MainpageContainer />
	</Box>
);
